<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import ButtonAlt from "@/dsComponents/buttons/ButtonAlt.vue";
import TextInputAlt from "@/dsComponents/inputs/TextInputAlt.vue";
import Modal from "@/dsComponents/modals/Modal.vue";
import TagTitle from "@/dsComponents/modals/TagTitle.vue";

interface JustificationModalProps {
    open: boolean;
    defaultText?: string;
    onValidate?: (value: string) => void;
}

const props = withDefaults(defineProps<JustificationModalProps>(), {
    defaultText: "",
});

const emit = defineEmits<(e: "close") => void>();

const { t } = useI18n();

const justification = ref(props.defaultText);

const handleClose = () => {
    emit("close");
};

const handleValidate = () => {
    props.onValidate?.(justification.value);
    emit("close");
};
</script>

<template>
    <Modal position="top" :open="props.open" @close="handleClose" width="720px" action close :z-index-level="2">
        <template #header>
            <TagTitle icon="answer-text" :label="t('page.order.justification')" />
        </template>
        <template #default>
            <TextInputAlt v-model="justification" :placeholder="t('page.order.addJustification')" variant="transparent" size="md" />
        </template>
        <template #footer>
            <div class="modal-actions">
                <ButtonAlt type="neutral" :label="t('global.actions.cancel')" @click="handleClose" />
                <ButtonAlt type="neutral" variant="filled" :label="t('global.actions.save')" @click="handleValidate" />
            </div>
        </template>
    </Modal>
</template>

<style scoped lang="scss">
.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-lg, 12px);
}
</style>
